import {ACTIONS} from './actionKeys';

export const addOverlay = () => ({
	type: ACTIONS.ADD_OVERLAY,
});

export const removeOverlay = () => ({
	type: ACTIONS.REMOVE_OVERLAY,
});
